<template>
  <van-popup
    v-model="isShowItem"
    position="bottom"
    round
    :style="`border-top-left-radius: 0.48rem;border-top-right-radius: 0.48rem;${styleCss}`"
    @click-overlay="hide"
  >
    <div class="popup-content" :style="styleCss">
      <div class="popup-title">
        <my-TitlePopup :title="title" @hide="hide" />
      </div>
      <component :is="isModules" @hide="hide" @onCheng="onCheng"></component>
    </div>
  </van-popup>
</template>
<script>
import framePopup from "./index";
export default {
  props: {
    //弹框样式
    styleCss: {
      type: String,
      default: "min-height: 9.74rem;",
    },
    //组件模块
    modules: {
      type: String,
      default: "myNftFrams",
    },
    //显示
    isShow: {
      type: Boolean,
      default: false,
    },
    //详情数据
    details: {
      type: Object,
      default: function () {
        return {};
      },
    },
    //标题
    title:{
        type:String,
        default:"title",
    },
  },
  data() {
    return {
      isShowItem: this.isShow,
      isModules: "", //公共模块
    };
  },
  watch: {
    isShow() {
      this.isShowItem = this.isShow;
    },
  },
  created() {
    console.log("传的数据", this.isShowItem);
    this.isModules = framePopup[this.modules];
  },
  methods: {
    hide(prams) {
      this.$emit("hide", prams);
    },
    onCheng(el){
        this.$emit("onCheng",el);
    }
  },
};
</script>
<style lang="scss" scoped>
.popup-content {
  height: 100%;
  width: 100%;
  .popup-title{
padding: 0.3rem 0.2rem;
  }
}
.goods-skeleton {
  height: 100%;
  padding: 0.5rem;
  border-top-left-radius: 0.48rem;
  border-top-right-radius: 0.48rem;
}
</style>
